import * as React from "react";
const SvgPlayLarge = (props) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 48 48", style: {
  enableBackground: "new 0 0 48 48"
}, xmlSpace: "preserve", ...props }, /* @__PURE__ */ React.createElement("style", { type: "text/css" }, "\n	.st0{fill:#FFFFFF;}\n"), /* @__PURE__ */ React.createElement("path", { className: "st0", d: "M4.9,47.5L43.1,24L4.9,0.5V47.5z" }));
export default SvgPlayLarge;
